import { useFeatureFlag, usePreloadFlags } from "./useFeatureFlag";
import flags from "../features/featureFlags/flags";
import { useSelector } from "react-redux";
import { selectIsMobileApp } from "../store/reducers/runtimeDetails";

const useAppModernisation = () => {
  // preload all flags we need at once for better performance
  const { loading } = usePreloadFlags([
    flags.APP_MODERNISATION,
    flags.FORCE_APP_MODE,
    flags.ENHANCED_SEARCH,
    flags.ENHANCED_COUNTER,
    flags.WEB_MODERNISATION,
  ]);

  const isMobileApp = useSelector(selectIsMobileApp);

  const { value: isAppModernisationEnabled } = useFeatureFlag(
    flags.APP_MODERNISATION,
    false,
    false, // autoFetch=false since we preloaded
  );
  const { value: isForceAppMode } = useFeatureFlag(
    flags.FORCE_APP_MODE,
    false,
    false,
  );
  const { value: isEnhancedSearchEnabled } = useFeatureFlag(
    flags.ENHANCED_SEARCH,
    false,
    false,
  );
  const { value: isEnhancedCounter } = useFeatureFlag(
    flags.ENHANCED_COUNTER,
    false,
    false,
  );
  const { value: isWebModernisationEnabled } = useFeatureFlag(
    flags.WEB_MODERNISATION,
    false,
    false,
  );

  const isAppMode =
    isAppModernisationEnabled && (isMobileApp || isForceAppMode);

  return {
    isAppMode,
    isEnhancedSearchEnabled,
    isEnhancedCounter,
    isWebModernisationEnabled,
    loading,
  };
};

export default useAppModernisation;
